export default {
  errorsRootKey: 'campaigns/utm-sources',
  resource: 'campaigns/utm-sources',
  actions: ['index', 'show', 'create', 'update', 'destroy']
}
